import styled from "@emotion/styled";

import Placeholder from "./placeholder.svg";

export const Container = styled.div`
  display: flex;
  justify-content: center;
`;

export const IframeWrapper = styled.div`
  z-index: 1;

  flex: 1;

  min-block-size: 1083px;
  ${props => props.theme.breakpoints.up("tablet")} {
    min-inline-size: 516px;
  }
`;

export const StyledPlaceholder = styled(Placeholder)`
  position: absolute;

  block-size: 100vh;
  margin-block: 63px;
  margin-inline: 0;
`;
